export const menuItems = [
  {
    id: 1,
    category: "Izgara Balıklar",
    name: "Levrek Izgara",
    description: "Günlük taze levrek, közde pişirilmiş, limon ve zeytinyağı ile",
    image: "https://public.readdy.ai/ai/img_res/efdb31c9818e4585a65005146cd27e63.jpg",
    tag: "Şef Önerisi",
  },
  {
    id: 2,
    category: "Izgara Balıklar",
    name: "Çipura Izgara",
    description: "Ege'nin incisi, sarımsak tereyağı ve taze otlar ile",
    image: "https://readdy.ai/api/search-image?query=grilled%20whole%20sea%20bream%20fish%20on%20white%20plate%2C%20golden%20crispy%20skin%2C%20garnished%20with%20garlic%20butter%20fresh%20herbs%20rosemary%20lemon%2C%20mediterranean%20restaurant%20presentation%2C%20professional%20food%20photography&width=400&height=300&seq=m2&orientation=landscape",
    tag: "",
  },
  {
    id: 3,
    category: "Kızartmalar",
    name: "Kalamar Tava",
    description: "Çıtır çıtır kalamar halkalar, ev yapımı tartar sos ile",
    image: "https://readdy.ai/api/search-image?query=crispy%20golden%20fried%20calamari%20rings%20piled%20on%20white%20plate%20with%20homemade%20tartar%20sauce%20and%20lemon%2C%20seafood%20restaurant%20appetizer%2C%20professional%20food%20photography%2C%20warm%20restaurant%20lighting&width=400&height=300&seq=m3&orientation=landscape",
    tag: "Popüler",
  },
  {
    id: 4,
    category: "Kızartmalar",
    name: "Hamsi Tava",
    description: "Karadeniz'in sevgilisi, mısır ununda kızartılmış taze hamsi",
    image: "https://readdy.ai/api/search-image?query=fried%20anchovies%20hamsi%20tava%20on%20white%20plate%20with%20cornmeal%20coating%2C%20golden%20crispy%20small%20fish%2C%20traditional%20turkish%20seafood%20dish%2C%20lemon%20slice%20garnish%2C%20professional%20food%20photography&width=400&height=300&seq=m4&orientation=landscape",
    tag: "Geleneksel",
  },
  {
    id: 5,
    category: "Mezeler",
    name: "Midye Dolma",
    description: "El yapımı, baharatlı pirinç ve fındık ile doldurulmuş",
    image: "https://readdy.ai/api/search-image?query=stuffed%20mussels%20midye%20dolma%20on%20white%20plate%2C%20traditional%20turkish%20street%20food%20elevated%20to%20restaurant%20quality%2C%20rice%20filling%20with%20pine%20nuts%20spices%2C%20lemon%20wedge%2C%20professional%20food%20photography&width=400&height=300&seq=m5&orientation=landscape",
    tag: "",
  },
  {
    id: 6,
    category: "Mezeler",
    name: "Deniz Mahsulleri Salatası",
    description: "Ahtapot, karides, midye — taze yeşillikler ve limon sosu",
    image: "https://readdy.ai/api/search-image?query=fresh%20seafood%20salad%20with%20octopus%20tentacles%20shrimp%20mussels%20on%20white%20plate%2C%20mixed%20greens%20arugula%20cherry%20tomatoes%20lemon%20dressing%2C%20mediterranean%20style%2C%20professional%20restaurant%20food%20photography&width=400&height=300&seq=m6&orientation=landscape",
    tag: "",
  },
  {
    id: 7,
    category: "Özel Tabaklar",
    name: "Balıkçı Tepsisi",
    description: "Günün balıkları, karides, kalamar ve midye — hepsi bir arada",
    image: "https://readdy.ai/api/search-image?query=large%20mixed%20seafood%20platter%20on%20wooden%20board%20with%20grilled%20fish%20shrimp%20calamari%20mussels%20lemon%20herbs%2C%20turkish%20seafood%20restaurant%20special%20dish%2C%20abundant%20and%20appetizing%2C%20professional%20food%20photography&width=400&height=300&seq=m7&orientation=landscape",
    tag: "Özel",
  },
  {
    id: 8,
    category: "Özel Tabaklar",
    name: "Ahtapot Izgara",
    description: "Közde pişirilmiş ahtapot, kapari ve zeytinyağı ile",
    image: "https://readdy.ai/api/search-image?query=grilled%20octopus%20on%20white%20plate%2C%20charred%20tentacles%20with%20olive%20oil%20capers%20lemon%2C%20mediterranean%20restaurant%20dish%2C%20professional%20food%20photography%2C%20rustic%20presentation&width=400&height=300&seq=m8&orientation=landscape",
    tag: "",
  },
];

export const menuCategories = ["Tümü", "Izgara Balıklar", "Kızartmalar", "Mezeler", "Özel Tabaklar"];
